import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useAssetsState = () => React.useContext(Context)
export const useAssets = () => useAssetsState()?.assets

const QUERY = gql`
  query Assets($ids: [Integer]) {
    assets(filter: { ids: $ids }) {
      id
      name
      enabled
      place {
        id
        name
        resume
        type
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          type
          name
        }
      }
      type {
        id
        name
        entity
        deleted
      }
      deleted
      insertedAt
      updatedAt
    }
  }
`

const AssetsLoader = ({ children }) => {
  const ids = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    skip: !ids?.length,
    variables: { ids },
    client: placesClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default AssetsLoader
